/* eslint-disable import/no-named-as-default-member */
/* eslint-disable eqeqeq */
import create from 'zustand';
import userApi from 'lib/api/user';
import produce from 'immer';
import chatApi from 'lib/api/chat';
import useChatStore from 'stores/chat';
import { IChatStore } from 'stores/chat/types';
import alertMessage from 'global/AlertMessage';
import { IRoomActionStore } from './types';

const roomActionStore = create<IRoomActionStore>((set) => ({
  isLoadingAcceptRequest: false,
  isLoadingRejectRequest: false,
  isLoadingAcceptInvitation: false,
  isLoadingDeleteInvitation: false,
  isLoadingBlockUnblock: false,
  respondRequestedRoom: ({ roomId, respond }) =>
    new Promise((resolve) => {
      set(
        produce((state: IRoomActionStore) => {
          if (respond === 'accept') {
            state.isLoadingAcceptRequest = true;
          } else {
            state.isLoadingRejectRequest = true;
          }
        }),
      );

      const request =
        respond === 'accept' ? chatApi.acceptRequest : chatApi.rejectRequest;

      request(roomId)
        .then((res) => {
          const { rooms } = useChatStore.getState();
          useChatStore.setState(
            produce((state: IChatStore) => {
              const roomIdx = rooms.invited.list.findIndex(
                (room) => room.id == roomId,
              );

              if (roomIdx > -1) {
                state.rooms.invited.list.splice(roomIdx, 1);
              }
            }),
          );

          set({
            isLoadingAcceptRequest: false,
            isLoadingRejectRequest: false,
          });

          resolve(res.data);
        })
        .catch(() => {
          set({
            isLoadingAcceptRequest: false,
            isLoadingRejectRequest: false,
          });
        });
    }),
  respondGroupInvitation: ({ chatId, action }) =>
    new Promise((resolve) => {
      set(
        produce((state: IRoomActionStore) => {
          if (action === 'ACTION_ACCEPT') {
            state.isLoadingAcceptInvitation = true;
          } else {
            state.isLoadingDeleteInvitation = true;
          }
        }),
      );

      chatApi
        .respondInvitation(chatId, action)
        .then((res) => {
          if (action === 'ACTION_REJECT') {
            const { rooms } = useChatStore.getState();

            const roomIdx = rooms.invited.list.findIndex(
              (room) => room.id == chatId,
            );
            if (roomIdx > -1) {
              useChatStore.setState(
                produce((state: IChatStore) => {
                  state.rooms.invited.list.splice(roomIdx, 1);
                }),
              );
            }
          }
          set({
            isLoadingAcceptInvitation: false,
            isLoadingDeleteInvitation: false,
          });

          resolve(res.data);
        })
        .catch(() => {
          set({
            isLoadingAcceptInvitation: false,
            isLoadingDeleteInvitation: false,
          });
        });
    }),
  blockUnblockUser: ({ userId, block, username }) =>
    new Promise((resolve) => {
      const request = block ? userApi.blockUser : userApi.unblockUser;

      request(userId)
        .then((res) => {
          const roomIdx = useChatStore
            .getState()
            .rooms.default.list.findIndex(
              (room) => room.attributes?.personal?.user_id === userId,
            );
          if (roomIdx > -1) {
            useChatStore.setState(
              produce((state: IChatStore) => {
                state.rooms.default.list[
                  roomIdx
                ].attributes.personal.is_blocked = block;
              }),
            );
          }

          if (block) {
            alertMessage({
              content: `${username} berhasil diblock `,
              alertType: 'snackbar',
              messageType: 'success',
              hasCloseIcon: true,
            });
          } else {
            alertMessage({
              content: `unblock ${username} berhasil`,
              alertType: 'snackbar',
              messageType: 'success',
              hasCloseIcon: true,
            });
          }

          resolve(res.data);
        })
        .catch(() => {
          alertMessage({
            content: 'Blocking user gagal',
            messageType: 'error',
            alertType: 'snackbar',
            hasCloseIcon: true,
          });
        });
    }),
  muteUnmuteRoom: ({ chatId, muted }) =>
    new Promise((resolve) => {
      chatApi
        .muteNotification(chatId, muted)
        .then((res) => {
          const { data } = res.data;

          if (data) {
            const roomIdx = useChatStore
              .getState()
              .rooms.default.list.findIndex(
                (room) =>
                  (room.type === 'ROOM_TYPE_GROUP' ||
                    room.type === 'ROOM_TYPE_BROADCAST') &&
                  room.id === parseInt(String(chatId), 10),
              );

            useChatStore.setState(
              produce((state: IChatStore) => {
                state.rooms.default.list[roomIdx].status.is_muted = muted;
              }),
            );

            if (muted) {
              alertMessage({
                content: 'Notification Muted',
                messageType: 'success',
                alertType: 'snackbar',
                hasCloseIcon: true,
              });
            } else {
              alertMessage({
                content: 'Notification Unmuted',
                messageType: 'success',
                alertType: 'snackbar',
                hasCloseIcon: true,
              });
            }
          }
          resolve(data);
        })
        .catch(() => {
          alertMessage({
            content: 'Gagal menyimpan aturan notifikasi',
            messageType: 'error',
            alertType: 'snackbar',
            hasCloseIcon: true,
          });
        });
    }),
}));

export default roomActionStore;
